package dev.danko.roblox_craft_ai.uikit.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.css.FlexWrap
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.danko.roblox_craft_ai.shared.model.ReportReason
import dev.danko.roblox_craft_ai.uikit.i18n.strings
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.TextArea

private const val MAX_COMMENT_LENGTH = 500

@Composable
fun ReportAssetDialog(
    visible: Boolean,
    sending: Boolean,
    onDismiss: () -> Unit,
    onSubmit: (reason: ReportReason, comment: String?) -> Unit
) {
    if (!visible) return
    val s = strings().report
    val palette = LocalAppTheme.current.colors
    var reason by remember { mutableStateOf(ReportReason.INAPPROPRIATE) }
    var comment by remember { mutableStateOf("") }

    ModalDialog(
        visible = true,
        onCloseRequest = onDismiss,
        title = s.title,
        footer = ModalDialogConfirmActions(
            confirmText = s.submit,
            onConfirm = { onSubmit(reason, comment.trim().takeIf { it.isNotEmpty() }) },
            onCancel = onDismiss,
            confirmVariant = AppButtonVariant.DANGER,
            confirmLoading = sending,
            confirmEnabled = !sending
        )
    ) {
        Column(Modifier.fillMaxWidth().gap(0.75.cssRem)) {
            SpanText(s.hint, Modifier.fontSize(0.85.cssRem).color(palette.textSecondary))
            SpanText(s.reasonLabel, Modifier.fontSize(0.8.cssRem).fontWeight(FontWeight.SemiBold).color(palette.textPrimary))
            Row(Modifier.fillMaxWidth().gap(0.4.cssRem).flexWrap(FlexWrap.Wrap)) {
                listOf(
                    ReportReason.INAPPROPRIATE to s.reasonInappropriate,
                    ReportReason.UNSAFE_CODE to s.reasonUnsafeCode,
                    ReportReason.COPYRIGHT to s.reasonCopyright,
                    ReportReason.OTHER to s.reasonOther
                ).forEach { (value, label) ->
                    AppButton(
                        text = label,
                        onClick = { reason = value },
                        variant = if (reason == value) AppButtonVariant.PRIMARY else AppButtonVariant.OUTLINE,
                        size = AppButtonSize.SM
                    )
                }
            }
            SpanText(s.commentLabel, Modifier.fontSize(0.8.cssRem).fontWeight(FontWeight.SemiBold).color(palette.textPrimary))
            TextArea(
                value = comment,
                attrs = Modifier
                    .fillMaxWidth()
                    .minHeight(4.cssRem)
                    .padding(0.625.cssRem)
                    .backgroundColor(palette.surface)
                    .color(palette.textPrimary)
                    .border(1.px, LineStyle.Solid, palette.border)
                    .borderRadius(0.375.cssRem)
                    .fontSize(0.875.cssRem)
                    .resize(Resize.Vertical)
                    .toAttrs {
                        attr("placeholder", s.commentPlaceholder)
                        attr("maxlength", MAX_COMMENT_LENGTH.toString())
                        onInput { comment = it.value.take(MAX_COMMENT_LENGTH) }
                    }
            )
        }
    }
}
